export default __webpack_public_path__ + "static/media/collapse-black.6d6574fa.svg";